import { ShopListProduct, ShopCompleteProduct } from 'microshop-api';

export enum PdfLayout {
    Standard = 0,
    Compact = 1,
    Miniature = 2,
}

export type PdfSettings = {
    useLandscape?: boolean;
    pageStartingNumber?: number;
    layout?: PdfLayout;
    showVariationImages?: boolean;
    showImagePicture?: boolean;
};

export type PdfSettingStakeholder = {
    name: string;
    company: string;
    phone: string;
    email: string;
    customerNumber?: string;
    imageUrl?: string; // ?? ref / buffer / url ?
    imageRef?: string;
    imageBuffer?: string;
    display: boolean;
};

export type PdfProduct = Omit<ShopListProduct, 'variations'> &
    Pick<
        ShopCompleteProduct,
        'marks' | 'sizeSummary' | 'attributes' | 'description' | 'customDescription' | 'variations'
    > & {
        // files?: ShopFile[] | null | undefined;
        // quantity?: number | null | undefined;
        // variations?: PdfVariation[] | undefined | null;
        // orderLines?: PdfOrderLine[] | null;
    };

export type PdfDocumentData = {
    // orderNumber?: string | null;
    // orderTables?: PdfOrder[];
    // orderType?: PdfOrderType;
    // sitePriceFormat: PriceFormatExtended;
    // hidePrice?: boolean;
    settings: PdfSettings;
    // coverImage?: string;
    // coverTitle: CoverPageTitle;
    // aboutPages: EpiImage[];
    // selectedSizeGuides: EpiImage[];
    // terms?: string | null;
    seller?: PdfSettingStakeholder;
    // customer?: PdfSettingStakeholder;
    // allRefinements: ExportDataRefinement[];
    products: PdfProduct[];
    // marks: Marks;
    // accessoryImages: Record<number, string | undefined>;
    fileName?: string;
    // origin: ExportOrigin;
    // isEmpty: boolean;
    // refinementWarnings?: RefinementWarnings;
    // showBarcode?: boolean;
    pageStartingNumber?: number;
};

export type PdfPageInfo = {
    seller?: PdfSettingStakeholder;
    orderNumber?: string | null;
};
